/* eslint-disable max-len */
import forEach from 'lodash/forEach';
import orderBy from 'lodash/orderBy';

export default ({ isCourseDraft, learningObjectives }) => {
  const orderedLearningObjectives = orderBy(learningObjectives, 'position');

  // Initialize root item
  const orderedLearningObjectivesList = {
    rootId: 'root',
    items: {
      root: {
        id: 'root',
        isChildrenLoading: false,
        hasChildren: true,
        isExpanded: true,
        data: { title: 'root' },
        children: [],
      },
    },
  };

  forEach(orderedLearningObjectives, (learningObjective) => {
    // Add each learning objective to the root item
    orderedLearningObjectivesList.items.root.children.push(learningObjective.id);

    orderedLearningObjectivesList.items[learningObjective.id] = {
      id: learningObjective.id,
      isChildrenLoading: false,
      hasChildren: false,
      isExpanded: true,
      children: [],
      data: { ...learningObjective, isCourseDraft },
    };
  });

  return orderedLearningObjectivesList;
};
